import {Component, Input, OnInit, Output, ElementRef} from '@angular/core';
import {AddressInterface} from '@interfaces/address.interface';
import {EventEmitter} from '@node_modules/@angular/core';
import {Address} from '@models/address';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {
  @Input() address_line_1: string = '';
  @Input() addressDisabled = true;
  @Output() addressChanged = new EventEmitter<AddressInterface>();
  @Output() addressCheck = new EventEmitter();
  @Output() fieldAddress = new EventEmitter();
  address: AddressInterface = new Address();
  options = {};
  fullAddress: boolean;
  savedAddress = '';
  constructor(
      private elRef: ElementRef,
  ) { }

  ngOnInit() {
  }
  handleAddressChange(event) {
    console.log(event);
    if (event.address_components) {
      this.address = new Address();
      this.fullAddress = true;
      const fullAddress = {
        street_number: false,
        route: false,
        locality: false,
        administrative_area_level_1: false,
        postal_code: false,
        country: false
      };

      event.address_components.map((item) => {
        if (item.types.includes('street_number')) {
          const address = this.address.address_line_1;
          if (!address || address.length === 0) {
            this.address.address_line_1 = item.long_name;
          } else {
            this.address.address_line_1 = address + ' ' + item.long_name;
          }
          fullAddress.street_number = true;
        } else {
          fullAddress.street_number ? fullAddress.street_number = true : fullAddress.street_number = false;
        }

        if (item.types.includes('route')) {
          const route = this.address.address_line_1;
          if (!route || route.length === 0) {
            this.address.address_line_1 = item.long_name;
          } else {
            this.address.address_line_1 = route + ' ' + item.long_name;
          }
          fullAddress.route = true;
        } else {
          fullAddress.route ? fullAddress.route = true : fullAddress.route = false;
        }

        if (item.types.includes('locality')) {
          this.address.locality = item.long_name;
          fullAddress.locality = true;
        } else {
          fullAddress.locality ? fullAddress.locality = true : fullAddress.locality = false;
        }

        if (item.types.includes('administrative_area_level_1')) {
          this.address.administrative_area_level_1 = item.short_name;
          fullAddress.administrative_area_level_1 = true;
        } else {
          fullAddress.administrative_area_level_1 ? fullAddress.administrative_area_level_1 = true : fullAddress.administrative_area_level_1 = false;
        }

        if (item.types.includes('postal_code')) {
          this.address.postal_code = item.short_name;
          fullAddress.postal_code = true;
        } else {
          fullAddress.postal_code ? fullAddress.postal_code = true : fullAddress.postal_code = false;
        }

        if (item.types.includes('country')) {
          this.address.country = item.short_name;
          fullAddress.country = true;
        } else {
          fullAddress.country ? fullAddress.country = true : fullAddress.country = false;
        }
      });
      const fullAddressResult = Object.keys(fullAddress).map(key => {
        return [String(key), fullAddress[key]];
      });

      fullAddressResult.map(item => {
        if (!item[1]) {
          this.fullAddress = false;
        }
      });

      if (!this.address.locality || this.address.locality.length === 0 ) {
        this.address.locality = this.address.administrative_area_level_1;
      }
      this.address.location_id  = event.place_id;

      this.addressChanged.emit(this.address);
      this.addressCheck.emit(this.fullAddress);
      this.fieldAddress.emit(this.elRef.nativeElement.querySelector('input').value);
      // if (this.fullAddress) {
      //   this.savedAddress = this.elRef.nativeElement.querySelector('input').value;
      // }
    }
  }
  handleBlur(event) {
    // console.log(this.address);
    // console.log(this.fullAddress);
    // console.log(this.savedAddress);
    // this.addressChanged.emit(this.address);
    // this.addressCheck.emit(this.fullAddress);
    // this.fieldAddress.emit(this.savedAddress);
    event.target.closest('app-address').classList.add('active-field');
  }
}
